import {isEmpty, createSelector} from 'helpers';
import {module} from 'store/common';
import {sorting} from 'store/sorting';
import {settings} from 'store/settings';

export const preferences = createSelector(
  [ module, settings, sorting ],
  ( module, settings, sorting ) => ({
    ...settings[module],
    hasCustomOrder: !isEmpty(sorting),
    isRecurring: /routine|habit/.test(module),
    module,
  }),
  { memoizeOptions: { maxSize: 10 } },
);
